import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const AboutCard = ({ logo, description1, description2, imageSrc, link }) => {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-200 bg-opacity-86 text-grey-700 p-6 rounded-sm shadow-md flex flex-col items-center relative transform transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-lg hover:bg-opacity-100">
      {/* Image Section */}
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={logo}
          className="w-[72px] h-[72px] object-contain mb-4"
        />
      ) : (
        <div className="w-[72px] h-[72px] bg-gray-300 flex items-center justify-center text-sm text-gray-600 mb-4">
          No Image
        </div>
      )}

      {/* Logo Section */}
      {link ? (
        <Link
          to={link}
          className="text-lg font-bold text-center break-words hover:text-grey-700 mb-2"
        >
          {logo}
        </Link>
      ) : (
        <div className="text-lg font-bold text-center break-words mb-2">
          {logo}
        </div>
      )}

      {/* Description Section */}
      <p className="text-center mb-2">{description1}</p>
      <p className="text-center mb-4">{description2}</p>

      {/* Link with Arrow */}
      <div className="mt-auto">
        <Link
          to={link || "#"}
          className="text-green-800 hover:scale-110 transform transition-all text-[1rem] flex items-center"
        >
          {t("Link.learnMore")}
          <span className="ml-2 text-xl">&#8594;</span>
        </Link>
      </div>
    </div>
  );
};

export default AboutCard;
